import { render, staticRenderFns } from "./BehaviorDepth.vue?vue&type=template&id=20d8eab7&scoped=true"
import script from "./BehaviorDepth.vue?vue&type=script&lang=js"
export * from "./BehaviorDepth.vue?vue&type=script&lang=js"
import style0 from "./BehaviorDepth.vue?vue&type=style&index=0&id=20d8eab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8eab7",
  null
  
)

export default component.exports